export enum focusStateTypes {
  NONE = 'none',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
